import React from 'react';
import { Box } from '@mui/material';
import { MessageSkeleton } from './MessageSkeleton';

interface MessageSkeletonGroupProps {
    count?: number; // Number of skeleton groups to display
}

/**
 * A component that renders groups of message skeletons to indicate loading state
 */
export const MessageSkeletonGroup: React.FC<MessageSkeletonGroupProps> = ({ count = 4 }) => {
    // Predefined skeleton patterns
    const skeletonPatterns = [
        // Pattern 1: 3 messages from left (same user)
        {
            align: 'left',
            messages: [{ connected: false }, { connected: true }, { connected: true }],
        },
        // Pattern 2: 2 messages from right (same user)
        {
            align: 'right',
            messages: [{ connected: false }, { connected: true }],
        },
        // Pattern 3: Single message from left
        {
            align: 'left',
            messages: [{ connected: false }],
        },
        // Pattern 4: 2 messages from right (same user)
        {
            align: 'right',
            messages: [{ connected: false }, { connected: true }],
        },
    ];

    // Generate the skeleton groups based on count
    const generateSkeletonGroups = () => {
        const groups = [];

        for (let i = 0; i < count; i++) {
            // Use modulo to cycle through patterns if more than 4 groups are requested
            const patternIndex = i % skeletonPatterns.length;
            const pattern = skeletonPatterns[patternIndex];

            groups.push(
                <Box key={i} sx={{ mb: 3 }}>
                    {pattern.messages.map((msg, msgIndex) => (
                        <MessageSkeleton
                            key={msgIndex}
                            align={pattern.align as 'left' | 'right'}
                            isConnected={msg.connected}
                        />
                    ))}
                </Box>,
            );
        }

        return groups;
    };

    return <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 2 }}>{generateSkeletonGroups()}</Box>;
};
